<template>
  <div>
    <b-button size="sm"
      variant="link"
      class="btn-tour-skip px-0  position-relative notification-bell mr-1"
      @click="updateUser()"
      v-b-popover="{title: 'Actualizar usuario', trigger: 'hover', placement: 'bottom', variant: 'danger'}">
      <feather-icon
        class="text-danger"
        icon="RefreshCcwIcon"
        size="23"
      />
    </b-button>
    <b-button
      size="sm"
      variant="link"
      class="btn-tour-skip px-0  position-relative notification-bell"
      :disabled="!readyNotifications"
      @click="showNotification()"
    >
      <feather-icon
        :badge="newNotifications || ''"
        badge-classes="bg-danger"
        class="text-body"
        icon="BellIcon"
        size="23"
      />
    </b-button>
    <div :class="showListNoti ? 'div-notification' : ''">
      <viewer-madagascar
        ref="viewerMadagascar"
        @closeNotification="showNotification"
        :showListNoti="showListNoti"
        @notificationsLoadedFromFirestore="notificationsLoadedFromFirestore"
        @handleTypeModal="handleTypeModal"
        @alertDisplayHandling="alertDisplayHandling"/>
    </div>
    <div>
      <modal-survey
        ref="modalSurvey"
        @handleTypeModal="handleTypeModal"
      />
    </div>
  </div>
  <!-- <b-nav-item-dropdown
    class="dropdown-notification mr-25"
    menu-class="dropdown-menu-media"
    right
  >
    <template #button-content>
      <feather-icon
        :badge="newNotifications || ''"
        badge-classes="bg-danger"
        class="text-body"
        icon="BellIcon"
        size="21"
      />
    </template>
      <div class="dropdown-header d-flex">
        <viewer/>
      </div>
  </b-nav-item-dropdown> -->
</template>

<script>
import { mapState } from 'vuex'
import ModalShowNotification from './ModalShowNotification.vue'
import { BBadge, BMedia, BLink, BAvatar, BButton, BNavItemDropdown } from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Ripple from 'vue-ripple-directive'
import ViewerMadagascar from '@/views/modules/configuration/communications/modules/components/ViewerMadagascar.vue'
import ModalSurvey from '@/views/modules/configuration/communications/modules/modals/ModalSurvey.vue'

export default {
  components: {
    // BNavItemDropdown,
    // BBadge,
    // BMedia,
    // BLink,
    // BAvatar,
    // VuePerfectScrollbar,
    // BButton,
    // ModalShowNotification,

    ViewerMadagascar,
    ModalSurvey
  },
  directives: {
    Ripple
  },
  data () {
    return {
      systemNotifications: [],
      loading: false,
      newNotifications: 0,
      indexNotification: -1,
      showListNoti: false,
      readyNotifications: false,
      isPopupOpen: false,
      commandQueue: [],
      CONDITIONS: Object.freeze({
        OPEN_NOTIFICATIONS_POPUP: 'OPEN_NOTIFICATIONS_POPUP',
        OPEN_SURVEY_POPUP: 'OPEN_SURVEY_POPUP'
      })
    }
  },
  computed: {
    ...mapState(['notifications'])
  },
  watch: {
    indexNotification (curr, prev) {
      if (curr !== -1) this.$store.dispatch('markAsRead', this.notifications.list[curr].id)
    }
  },
  methods : {
    openNotification (_id) {
      this.indexNotification = this.notifications.list.findIndex(({id}) => id === _id)
      this.$bvModal.show('modalShowNotification')
    },
    showNotification() {
      this.showListNoti = !this.showListNoti
    },
    updateUser() {
      const user = this.$session.get('cas_user')
      if (user && user.id && user.token) {
        this.$store.dispatch('fetchUserData', { id: user.id, token: user.token, from: 'app-render' })
      }
    },
    notificationsLoadedFromFirestore (value) {
      this.readyNotifications = value
    },
    openTypePopup () {
      const nextCommand = this.commandQueue.shift()
      this.isPopupOpen = true
      nextCommand === this.CONDITIONS.OPEN_NOTIFICATIONS_POPUP ? this.$refs.viewerMadagascar.showViewer() : this.$bvModal.show('modalSurvey')
    },
    closeTypePopup (type) {
      type === this.CONDITIONS.OPEN_NOTIFICATIONS_POPUP ? this.$refs.viewerMadagascar.hideViewer() : this.$bvModal.hide('modalSurvey')
      this.isPopupOpen = false
      this.processNextCommand()
    },
    handleTypeModal (value, type) {
      if (!!value) {
        this.commandQueue.push(this.CONDITIONS[type])
        this.processNextCommand()
      } else {
        this.closeTypePopup(type)
      }
    },
    processNextCommand() {
      if (this.commandQueue.length === 0 || this.isPopupOpen) return
      this.openTypePopup()
    },
    alertDisplayHandling (count) {
      this.newNotifications = count
    }
  },
  setup() {
    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false
    }

    return {
      perfectScrollbarSettings
    }
  }
}
</script>

<style>
.div-notification{
  position: absolute;
  top: -1rem;
  background: #161d311c;
  width: 150%;
  height: 100vh;
  left: -2rem;
  padding: 0;
  z-index: 9999 !important;
}
.button-ws, .button-ws:focus{
  padding: 0.7rem 1rem;
  border-color: #27D045 !important;
  background-color: #27D045 !important;
}
.margin-img-ws {
  margin-right: 0.2rem;
}
.notification-bell .badge {
  top: -14px;
  right: -3px;
  width: 14px;
  height: 14px;
  min-width: 0;
  min-height: 0;
  background-color: #DC1111 !important;
  border-radius: 50%;
  color: white;
  font-size: 8px;
  font-weight: bold;
  padding-bottom: 0.5px;
  padding: 0 0.25rem 0.5px 0.25rem;
}
</style>
